import React, { useState } from 'react';
import { X, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const STAFF_ROLES = ['Sala', 'Cucina', 'Pizzeria'];

const GalleryPage = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [filter, setFilter] = useState('all');       // all | Staff | Eventi
  const [subFilter, setSubFilter] = useState('all'); // all | Sala | Cucina | Pizzeria

  // Foto — category: 'Staff' o 'Eventi'; per Staff `roles` è un array Sala/Cucina/Pizzeria
  const allPhotos = [
    { url: '/images/staff/staff-1.jpg', title: 'Katerina — Responsabile di Cucina', category: 'Staff', roles: ['Cucina'] },
    { url: '/images/staff/staff-bruno.jpg', title: 'Bruno — Responsabile di Cucina', category: 'Staff', roles: ['Cucina'] },
    { url: '/images/staff/staff-carolina.jpg', title: 'Carolina — Collaboratrice di Sala', category: 'Staff', roles: ['Sala'] },
    { url: '/images/staff/staff-daniele.jpg', title: 'Daniele — Responsabile di Pizzeria', category: 'Staff', roles: ['Pizzeria'] },
    { url: '/images/staff/staff-filippo.jpg', title: 'Filippo — Aiuto Cuoco / Pizzaiolo', category: 'Staff', roles: ['Cucina', 'Pizzeria'] },
    { url: '/images/staff/staff-jasbir.jpg', title: 'Jasbir — Collaboratrice di Cucina', category: 'Staff', roles: ['Cucina'] },
    { url: '/images/staff/staff-laura.jpg', title: 'Laura — Collaboratrice di Pizzeria', category: 'Staff', roles: ['Pizzeria'] },
    { url: '/images/staff/staff-leandro.jpg', title: 'Leandro — Responsabile di Sala', category: 'Staff', roles: ['Sala'] },
    { url: '/images/staff/staff-leatitia.jpg', title: 'Leatitia — Collaboratrice di Sala', category: 'Staff', roles: ['Sala'] },
    { url: '/images/staff/staff-lorenzo.jpg', title: 'Lorenzo — Responsabile Banco & Social', category: 'Staff', roles: ['Sala'] },
    { url: '/images/staff/staff-manik.jpg', title: 'Manik — Collaboratore di Sala', category: 'Staff', roles: ['Sala'] },
    { url: '/images/staff/staff-martina.jpg', title: 'Martina — Responsabile di Sala', category: 'Staff', roles: ['Sala'] },
    { url: '/images/staff/staff-martina2.jpg', title: 'Martina — Collaboratrice di Sala', category: 'Staff', roles: ['Sala'] },
    { url: '/images/staff/staff-matteo.jpg', title: 'Matteo — Collaboratore di Sala', category: 'Staff', roles: ['Sala'] },
    { url: '/images/staff/staff-saverio.jpg', title: 'Saverio — Collaboratore di Sala & Responsabile Domicili', category: 'Staff', roles: ['Sala'] },
    { url: '/images/staff/staff-simona.jpg', title: 'Simona — Collaboratrice di Cucina', category: 'Staff', roles: ['Cucina'] },
    { url: '/images/staff/staff-valeria.jpg', title: 'Valeria — Collaboratrice di Sala', category: 'Staff', roles: ['Sala'] },
    // Eventi — senza titolo/descrizione
    { url: '/images/eventi/eventi-1.jpg', title: '', category: 'Eventi' },
    { url: '/images/eventi/eventi-2.jpg', title: '', category: 'Eventi' },
    { url: '/images/eventi/eventi-3.jpg', title: '', category: 'Eventi' },
    { url: '/images/eventi/eventi-4.jpg', title: '', category: 'Eventi' },
    { url: '/images/eventi/eventi-5.jpg', title: '', category: 'Eventi' },
    { url: '/images/eventi/eventi-6.jpg', title: '', category: 'Eventi' },
    { url: '/images/eventi/eventi-7.jpg', title: '', category: 'Eventi' },
    { url: '/images/eventi/eventi-8.jpg', title: '', category: 'Eventi' },
    { url: '/images/eventi/eventi-9.jpg', title: '', category: 'Eventi' },
    { url: '/images/eventi/eventi-10.jpg', title: '', category: 'Eventi' },
    { url: '/images/eventi/eventi-11.jpg', title: '', category: 'Eventi' },
    { url: '/images/eventi/eventi-12.jpg', title: '', category: 'Eventi' },
    { url: '/images/eventi/eventi-13.jpg', title: '', category: 'Eventi' },
    { url: '/images/eventi/eventi-14.jpg', title: '', category: 'Eventi' },
    { url: '/images/eventi/eventi-15.jpg', title: '', category: 'Eventi' },
    { url: '/images/eventi/eventi-16.jpg', title: '', category: 'Eventi' },
    { url: '/images/eventi/eventi-17.jpg', title: '', category: 'Eventi' },
    { url: '/images/eventi/eventi-18.jpg', title: '', category: 'Eventi' },
    { url: '/images/eventi/eventi-19.jpg', title: '', category: 'Eventi' },
    { url: '/images/eventi/eventi-20.jpg', title: '', category: 'Eventi' },
    { url: '/images/eventi/eventi-21.jpg', title: '', category: 'Eventi' },
    { url: '/images/eventi/eventi-22.jpg', title: '', category: 'Eventi' },
    { url: '/images/eventi/eventi-23.jpg', title: '', category: 'Eventi' },
    { url: '/images/eventi/eventi-24.jpg', title: '', category: 'Eventi' },
    { url: '/images/eventi/eventi-25.jpg', title: '', category: 'Eventi' },
    { url: '/images/eventi/eventi-26.jpg', title: '', category: 'Eventi' },
    { url: '/images/eventi/eventi-27.jpg', title: '', category: 'Eventi' },
    { url: '/images/eventi/eventi-28.jpg', title: '', category: 'Eventi' },
    { url: '/images/eventi/eventi-29.jpg', title: '', category: 'Eventi' },
    { url: '/images/eventi/eventi-30.jpg', title: '', category: 'Eventi' },
    { url: '/images/eventi/eventi-31.jpg', title: '', category: 'Eventi' },
    { url: '/images/eventi/eventi-32.jpg', title: '', category: 'Eventi' },
    { url: '/images/eventi/eventi-33.jpg', title: '', category: 'Eventi' },
    { url: '/images/eventi/eventi-34.jpg', title: '', category: 'Eventi' },
    { url: '/images/eventi/eventi-35.jpg', title: '', category: 'Eventi' },
    { url: '/images/eventi/eventi-36.jpg', title: '', category: 'Eventi' },
    { url: '/images/eventi/eventi-37.jpg', title: '', category: 'Eventi' },
    { url: '/images/eventi/eventi-38.jpg', title: '', category: 'Eventi' },
    { url: '/images/eventi/eventi-39.jpg', title: '', category: 'Eventi' },
    { url: '/images/eventi/eventi-40.jpg', title: '', category: 'Eventi' },
  ];

  const categories = ['all', 'Staff', 'Eventi'];

  const handleFilterChange = (cat) => {
    setFilter(cat);
    setSubFilter('all');
  };

  const filteredPhotos = allPhotos.filter((p) => {
    if (filter === 'all') return true;
    if (p.category !== filter) return false;
    if (filter === 'Staff' && subFilter !== 'all') {
      return Array.isArray(p.roles) && p.roles.includes(subFilter);
    }
    return true;
  });

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow-md sticky top-0 z-40">
        <div className="container mx-auto px-6 py-6">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center space-x-2 text-[#7f9e60] hover:text-[#6a8550] transition-colors">
              <ArrowLeft size={24} />
              <span className="font-semibold">Torna alla Home</span>
            </Link>
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>
              La Nostra Gallery
            </h1>
            <div className="w-32"></div>
          </div>
        </div>
      </div>

      <div className="container mx-auto px-6 py-12">
        {/* Primary Filter */}
        <div className="flex flex-wrap justify-center gap-3 mb-4" data-testid="gallery-filter-primary">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => handleFilterChange(category)}
              data-testid={`filter-${category}`}
              className={`px-6 py-2 rounded-full font-semibold transition-all duration-300 ${
                filter === category
                  ? 'bg-[#7f9e60] text-white shadow-lg scale-105'
                  : 'bg-white text-gray-700 hover:bg-gray-100'
              }`}
            >
              {category === 'all' ? 'Tutti' : category}
            </button>
          ))}
        </div>

        {/* Sub Filter — solo per Staff */}
        {filter === 'Staff' && (
          <div className="flex flex-wrap justify-center gap-2 mb-12" data-testid="gallery-filter-sub">
            <button
              onClick={() => setSubFilter('all')}
              data-testid="subfilter-all"
              className={`px-4 py-1.5 rounded-full text-sm font-medium transition-all duration-300 ${
                subFilter === 'all'
                  ? 'bg-gray-900 text-white shadow'
                  : 'bg-white text-gray-600 hover:bg-gray-100 border border-gray-200'
              }`}
            >
              Tutto lo Staff
            </button>
            {STAFF_ROLES.map((role) => (
              <button
                key={role}
                onClick={() => setSubFilter(role)}
                data-testid={`subfilter-${role}`}
                className={`px-4 py-1.5 rounded-full text-sm font-medium transition-all duration-300 ${
                  subFilter === role
                    ? 'bg-gray-900 text-white shadow'
                    : 'bg-white text-gray-600 hover:bg-gray-100 border border-gray-200'
                }`}
              >
                {role}
              </button>
            ))}
          </div>
        )}

        {filter !== 'Staff' && <div className="mb-8"></div>}

        {/* Photos Grid */}
        {filteredPhotos.length === 0 ? (
          <div className="text-center py-20 bg-white rounded-2xl shadow-sm" data-testid="gallery-empty">
            <p className="text-2xl font-bold text-gray-700 mb-2" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>
              Foto in arrivo
            </p>
            <p className="text-gray-500">
              {filter === 'Eventi'
                ? 'Stiamo preparando le foto degli eventi.'
                : 'Nessuna foto in questa categoria.'}
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {filteredPhotos.map((photo) => (
              <div
                key={photo.url}
                className="group relative overflow-hidden rounded-xl aspect-square cursor-pointer shadow-lg hover:shadow-2xl transition-all duration-500"
                onClick={() => setSelectedImage(photo)}
              >
                <img
                  src={photo.url}
                  alt={photo.title}
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                {/* Content */}
                <div className="absolute inset-0 p-4 flex flex-col justify-end opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <span className="inline-block px-3 py-1 bg-[#7f9e60] text-white text-xs font-semibold rounded-full mb-2 w-fit">
                    {photo.category === 'Staff' && photo.roles ? photo.roles.join(' · ') : photo.category}
                  </span>
                  {photo.title && (
                    <h3 className="text-lg font-bold text-white" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>
                      {photo.title}
                    </h3>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 z-50 bg-black/95 backdrop-blur-sm flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="absolute top-6 right-6 w-14 h-14 bg-white/10 border border-white/20 rounded-full flex items-center justify-center text-white hover:bg-white/20 transition-colors duration-300"
            onClick={() => setSelectedImage(null)}
            data-testid="lightbox-close"
          >
            <X size={28} />
          </button>

          <div className="max-w-5xl w-full" onClick={(e) => e.stopPropagation()}>
            <img
              src={selectedImage.url}
              alt={selectedImage.title}
              className="w-full h-auto rounded-2xl shadow-2xl max-h-[75vh] object-contain"
            />
            <div className="text-center mt-8">
              <span className="inline-block px-4 py-2 bg-[#7f9e60] text-white text-sm font-semibold rounded-full mb-3">
                {selectedImage.category === 'Staff' && selectedImage.roles
                  ? selectedImage.roles.join(' · ')
                  : selectedImage.category}
              </span>
              {selectedImage.title && (
                <h3 className="text-4xl font-bold text-white" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>
                  {selectedImage.title}
                </h3>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GalleryPage;
